import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@core/analytics-legacy';
import { findStepForSubtask } from '@core/getting-started-data';
import type { GettingStartedSubtask } from '@core/getting-started-types';

@Injectable({ providedIn: 'root' })
export class GettingStartedAnalyticsService extends AnalyticsBase {
  public readonly namespace = 'Onboarding';
  public readonly requireViewContext = false;

  public trackGetStarted(subtaskName: GettingStartedSubtask, action: string): void {
    this.track(`${findStepForSubtask(subtaskName)} ${subtaskName}`, { action });
  }

  public trackDrawerEvents(eventName: string, action: string): void {
    this.track(`gettingStarted ${eventName}`, { action });
  }
}
